/* unplugin-vue-components disabled */import script from "./PublishStep.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishStep.vue?vue&type=script&setup=true&lang=js"

import "./PublishStep.vue?vue&type=style&index=0&id=78000837&lang=scss&scoped=true"
import "./PublishStep.vue?vue&type=style&index=1&id=78000837&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78000837"]])

export default __exports__